// Constants
import { CompanyName } from '../constants/Constants';
// Gallery Images
import BigHeels from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-big-heels.webp';
import BlackTshirt from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-black-tshirt.webp';
import HeelsAndAss from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-heels-and-ass.webp';
import HotAss from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-hot-ass.webp';
import HotAssSmall from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-hot-ass-small.webp';
import LuxuryQueen from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-luxury-queen.webp';
import OnStool from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-on-stool.webp';
import Selfie from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-selfie.webp';
import ShortSkirt from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-short-skirt.webp';
import StrongLegs from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-strong-legs.webp';
import WhiteBoots from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-white-boots.webp';
import BlackBoots from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-black-boots.webp';
import StraponCage from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-strap-on-cage.webp';
import MuscleQueen from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-muscle-queen.webp';
import BlackQueen from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-in-black.webp';
import WhipsAndBoots from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-whips-and-boots.webp';
import MuscleGoddess from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-muscle-goddess.webp';
import PeggingQueen from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-pegging-queen.webp';
import CollarQueen from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-lead-and-collar.webp';
import Img1 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-about-me.webp';
import Img2 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-in-white.webp';
import Img3 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-strong-woman-in-white.webp';
import Img4 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-black-gloves.webp';
import Img5 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-high-heels.webp';
import Img6 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-tattoo-thigh.webp';
import Img7 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-black-lingerie.webp';
import Img8 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-in-mirror.webp';
import Img9 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-sexy-pose.webp';
import Img10 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-ass-in-mirror.webp';
import Img11 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-pose-on-sofa.webp';
import ImgX from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-srtong-arm.webp';
import ImgY from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-srtong-arm-high-heels.webp';
import BlackLingerie1 from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-black-lingerie-1.webp';
import BlackLingerie2 from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-black-lingerie-2.webp';
import BlackLingerie3 from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-black-lingerie-3.webp';
import HoodedSlave1 from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-hooded-slave-1.webp';
import HoodedSlave2 from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-hooded-slave-3.webp';
import KitchenQueen from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-kitchen-queen.webp';
import StrapOn2 from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-pruple-strap-on-2.webp';
import PurpleSissy from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-purple-sissy.webp';
import StrapOn1 from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-purple-strap-on-1.webp';
import QueenOfAll from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-queen-of-all.webp';
import RedLatex from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-red-latex.webp';
import RedStrapOn from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-red-strap-on.webp';
import SissyFootRest from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-sissy-foot-rest.webp';
import SissyMaid1 from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-sissy-maid-1.webp';
import SissyMaid2 from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-sissy-maid-2.webp';
import Stairs from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-stairs.webp';
import TightPants from '../../assets/images/gallery/queen-blaire-dominatrix-and-prodomme-tight-pants.webp';

export const galleryImagesArray = [
  {
    src: KitchenQueen,
    alt: `${CompanyName} - Kitchen Queen`,
    name: 'Kitchen Queen',
    date: 'April 10, 2025',
  },
  {
    src: Img5,
    alt: `${CompanyName} - High Heels`,
    name: 'High Heels',
    date: 'April 10, 2025',
  },
  {
    src: RedLatex,
    alt: `${CompanyName} - Red Latex`,
    name: 'Red Latex',
    date: 'April 10, 2025',
  },
  {
    src: BlackLingerie2,
    alt: `${CompanyName} - Black Lingerie 2`,
    name: 'Black Lingerie 2',
    date: 'April 10, 2025',
  },
  {
    src: Img10,
    alt: `${CompanyName} - Ass in Mirror`,
    name: 'Ass in Mirror',
    date: 'April 10, 2025',
  },
  {
    src: StrongLegs,
    alt: `${CompanyName} - Strong Legs`,
    name: 'Strong Legs',
    date: 'April 10, 2025',
  },
  {
    src: HeelsAndAss,
    alt: `${CompanyName} - Heels & Ass`,
    name: 'Heels & Ass',
    date: 'April 10, 2025',
  },
  {
    src: Img3,
    alt: `${CompanyName} - Strong Woman in White`,
    name: 'Strong Woman in White',
    date: 'April 10, 2025',
  },
  {
    src: BlackBoots,
    alt: `${CompanyName} - Black Boots`,
    name: 'Black Boots',
    date: 'April 10, 2025',
  },
  {
    src: StrapOn2,
    alt: `${CompanyName} - Purple Strap-On 2`,
    name: 'Purple Strap-On 2',
    date: 'April 10, 2025',
  },
  {
    src: Img2,
    alt: `${CompanyName} - In White`,
    name: 'In White',
    date: 'April 10, 2025',
  },
  {
    src: Img11,
    alt: `${CompanyName} - Pose on Sofa`,
    name: 'Pose on Sofa',
    date: 'April 10, 2025',
  },
  {
    src: PurpleSissy,
    alt: `${CompanyName} - Purple Sissy`,
    name: 'Purple Sissy',
    date: 'April 10, 2025',
  },
  {
    src: Img8,
    alt: `${CompanyName} - In Mirror`,
    name: 'In Mirror',
    date: 'April 10, 2025',
  },
  {
    src: Img1,
    alt: `${CompanyName} - About Me`,
    name: 'About Me',
    date: 'April 10, 2025',
  },
  {
    src: SissyFootRest,
    alt: `${CompanyName} - Sissy Foot Rest`,
    name: 'Sissy Foot Rest',
    date: 'April 10, 2025',
  },
  {
    src: BlackLingerie1,
    alt: `${CompanyName} - Black Lingerie 1`,
    name: 'Black Lingerie 1',
    date: 'April 10, 2025',
  },
  {
    src: HotAss,
    alt: `${CompanyName} - Hot Ass`,
    name: 'Hot Ass',
    date: 'April 10, 2025',
  },
  {
    src: Img9,
    alt: `${CompanyName} - Sexy Pose`,
    name: 'Sexy Pose',
    date: 'April 10, 2025',
  },
  {
    src: OnStool,
    alt: `${CompanyName} - On Stool`,
    name: 'On Stool',
    date: 'April 10, 2025',
  },
  {
    src: WhiteBoots,
    alt: `${CompanyName} - White Boots`,
    name: 'White Boots',
    date: 'April 10, 2025',
  },
  {
    src: Img4,
    alt: `${CompanyName} - Black Gloves`,
    name: 'Black Gloves',
    date: 'April 10, 2025',
  },
  {
    src: BlackLingerie3,
    alt: `${CompanyName} - Black Lingerie 3`,
    name: 'Black Lingerie 3',
    date: 'April 10, 2025',
  },
  {
    src: Img7,
    alt: `${CompanyName} - Black Lingerie`,
    name: 'Black Lingerie',
    date: 'April 10, 2025',
  },
  {
    src: TightPants,
    alt: `${CompanyName} - Tight Pants`,
    name: 'Tight Pants',
    date: 'April 10, 2025',
  },
  {
    src: SissyMaid1,
    alt: `${CompanyName} - Sissy Maid 1`,
    name: 'Sissy Maid 1',
    date: 'April 10, 2025',
  },
  {
    src: QueenOfAll,
    alt: `${CompanyName} - Queen of All`,
    name: 'Queen of All',
    date: 'April 10, 2025',
  },
  {
    src: HoodedSlave1,
    alt: `${CompanyName} - Hooded Slave 1`,
    name: 'Hooded Slave 1',
    date: 'April 10, 2025',
  },
  {
    src: ImgY,
    alt: `${CompanyName} - About Me`,
    name: 'About Me',
    date: 'April 10, 2025',
  },
  {
    src: Stairs,
    alt: `${CompanyName} - Stairs`,
    name: 'Stairs',
    date: 'April 10, 2025',
  },
  {
    src: RedStrapOn,
    alt: `${CompanyName} - Red Strap-On`,
    name: 'Red Strap-On',
    date: 'April 10, 2025',
  },
  {
    src: Img6,
    alt: `${CompanyName} - Tattoo Thigh`,
    name: 'Tattoo Thigh',
    date: 'April 10, 2025',
  },
  {
    src: BlackQueen,
    alt: `${CompanyName} - Black Outfit`,
    name: 'Black Outfit',
    date: 'April 10, 2025',
  },
  {
    src: ImgX,
    alt: `${CompanyName} - About Me`,
    name: 'About Me',
    date: 'April 10, 2025',
  },
  {
    src: LuxuryQueen,
    alt: `${CompanyName} - Luxury Queen`,
    name: 'Luxury Queen',
    date: 'April 10, 2025',
  },
  {
    src: StrapOn1,
    alt: `${CompanyName} - Purple Strap-On 1`,
    name: 'Purple Strap-On 1',
    date: 'April 10, 2025',
  },
  {
    src: WhipsAndBoots,
    alt: `${CompanyName} - Whips and Boots`,
    name: 'Whips and Boots',
    date: 'April 10, 2025',
  },
  {
    src: BigHeels,
    alt: `${CompanyName} - Big Heels`,
    name: 'Big Heels',
    date: 'April 10, 2025',
  },
  {
    src: SissyMaid2,
    alt: `${CompanyName} - Sissy Maid 2`,
    name: 'Sissy Maid 2',
    date: 'April 10, 2025',
  },
  {
    src: HoodedSlave2,
    alt: `${CompanyName} - Hooded Slave 2`,
    name: 'Hooded Slave 2',
    date: 'April 10, 2025',
  },
  {
    src: Selfie,
    alt: `${CompanyName} - Selfie`,
    name: 'Selfie',
    date: 'April 10, 2025',
  },
  {
    src: MuscleQueen,
    alt: `${CompanyName} - Muscle Queen`,
    name: 'Muscle Queen',
    date: 'April 10, 2025',
  },
];


export const smallGalleryImagesArray = [
  {
    id: 1,
    src: BigHeels,
    name: 'Big Heels Command',
    alt: `${CompanyName} in towering heels`,
    ariaLabel: 'Gallery image 1',
  },
  {
    id: 2,
    src: LuxuryQueen,
    name: 'Black Tee Attitude',
    alt: `${CompanyName} in a bold black T-shirt pose`,
    ariaLabel: 'Gallery image 2',
  },
  {
    id: 3,
    src: HeelsAndAss,
    name: 'Heels and Attitude',
    alt: `${CompanyName} showing dominance and allure`,
    ariaLabel: 'Gallery image 3',
  },
  {
    id: 4,
    src: HotAssSmall,
    name: 'Hot Look',
    alt: `${CompanyName} flaunting her style`,
    ariaLabel: 'Gallery image 4',
  },
  {
    id: 5,
    src: OnStool,
    alt: `${CompanyName} - On Stool`,
    name: 'On Stool',
    date: 'April 10, 2025',
  },
  {
    id: 6,
    src: PeggingQueen,
    alt: `${CompanyName} - Pegging Queen`,
    name: 'Pegging Queen',
    date: 'April 10, 2025',
  },
  {
    id: 7,
    src: BlackQueen,
    alt: `${CompanyName} - Queen in Black`,
    name: 'Queen in Black',
    date: 'April 10, 2025',
  },
  {
    id: 8,
    src: CollarQueen,
    alt: `${CompanyName} - Collar Queen`,
    name: 'Collar Queen',
    date: 'April 10, 2025',
  },
];
